import { decodeJsonCookieValue } from 'common/utils/decodeJsonCookieValue';

!(function() {
  var analytics = (window.analytics = window.analytics || []);
  if (!analytics.initialize)
    if (analytics.invoked)
      window.console &&
        console.error &&
        console.error('Segment snippet included twice.');
    else {
      analytics.invoked = !0;
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
      ];
      analytics.factory = function(t) {
        return function() {
          var e = Array.prototype.slice.call(arguments);
          e.unshift(t);
          analytics.push(e);
          return analytics;
        };
      };
      for (var t = 0; t < analytics.methods.length; t++) {
        var e = analytics.methods[t];
        analytics[e] = analytics.factory(e);
      }
      analytics.load = function(t) {
        var e = document.createElement('script');
        e.type = 'text/javascript';
        e.async = !0;
        e.src =
          ('https:' === document.location.protocol ? 'https://' : 'http://') +
          'cdn.segment.com/analytics.js/v1/' +
          t +
          '/analytics.min.js';
        var n = document.getElementsByTagName('script')[0];
        n.parentNode.insertBefore(e, n);
      };
      analytics.SNIPPET_VERSION = '4.0.0';

      // The lines below were changed from the file provided by Segment

      // get the locale from the document or browser.
      var userLanguage = (document.documentElement.lang || navigator.language
      ).toLowerCase();
      var locale = (function(language) {
        switch (language) {
          case 'en-us':
            // default language in iterable is en, also for US
            return 'en';
          case 'en-gb':
            // locale in iterable was set to en-uk instead of en-gb
            return 'en-uk';
          default:
            return language;
        }
      })(userLanguage);

      var gon = global.gon;
      analytics.load(gon.env.SEGMENT_WRITE_KEY);

      // If the user is not currently logged in, use any previously set user id instead of null
      // This results in events being logged to a user even after their session times out, up until they
      // sign in as a different user
      var userId =
        _.get(gon, 'user.id') || decodeJsonCookieValue('ajs_user_id');
      var userEmail = _.get(gon, 'user.email');
      var anonymousId = decodeJsonCookieValue('juul_anonymous_id');

      analytics.identify(
        userId,
        {
          email: userEmail,
          locale: locale,
          geo_location: gon.geo_location,
        },
        {
          anonymousId: anonymousId,
        }
      );

      analytics.page(gon.page.name);
    }
})();



// WEBPACK FOOTER //
// ./app/javascript/vendor/segment.js